var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToggleButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 14.667,
    viewBox: "0 0 22 14.667",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-md-menu",
    "data-name": "Icon ionic-md-menu",
    d: "M4.5,23.667h22V21.222H4.5Zm0-6.111h22V15.111H4.5ZM4.5,9v2.444h22V9Z",
    transform: "translate(-4.5 -9)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggleButton);
export default __webpack_public_path__ + "static/media/toggleButton.45352bf0059507898d097338c4fb440e.svg";
export { ForwardRef as ReactComponent };